// GeneLoginReducer.js

import { SET_GINNE_LOGIN } from "../Action/GeneLoginAction";

const initialState = {
  isGinneLogin: false, // Default state
};

const geneLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GINNE_LOGIN:
      return {
        ...state,
        isGinneLogin: action.payload,
      };
    default:
      return state;
  }
};

export default geneLoginReducer; // Export the reducer as default
